import Authorization from "../../generics/authorization";
import TabNavigation from "../../common/TabNavigation";
import { MFE_COMPONENT_IDS } from "../../utils/enums";

const pageProps = {
  filterDashlets: [
    {
      component: TabNavigation,
      name: "tab-nav",
      layout: { x: 0, y: 0, w: 10.5, h: 4 }
    }
  ],
  componentId: MFE_COMPONENT_IDS.APPLICATIONS // MFE
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
